<main #trendingContainer class="trending-container cinema-section" *ngIf="recommendations && recommendations.length">

  <!-- ================= HEADER ================= -->
  <section #trendingHeader class="d-flex align-items-center flex-row switch-header cinema-section-header cinema-toggle-header">      
    <section class="my-2 cinema-title-shell">
      <div class="d-flex align-items-center cinema-title-group">
        <h3 class="heading-text mb-0 cinema-section-title">{{ languageService.t('recommendations') }}</h3>
      </div>
    </section>
  </section>

  <!-- ================= BACKGROUND SECTION ================= -->
  <section class="trailer-movie-section py-4"
    [ngStyle]="{
      'background-image': (recommendations && recommendations.length && recommendations[selectedItemIndex]?.backdrop_path) ? 'url(https://image.tmdb.org/t/p/w1280' + recommendations[selectedItemIndex]?.backdrop_path + ')' : 'none'
    }">
    <div class="smoke-effect smoke-left"></div>
    <div class="image-overlay"></div>

    <!-- ================= SKELETON ================= -->
    <div *ngIf="isLoading" class="skeleton-wrapper py-2">
      <div class="trailer-skeleton-container">
        <div class="trailer-card-wrapper trailer-skeleton-item" *ngFor="let _ of initialSkeletons">
          <div class="trailer-skeleton-card">
            <div class="skeleton-shimmer-wrap">
              <div class="skeleton-shimmer"></div>
            </div>
            <div class="trailer-skeleton-play-btn">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="6 3 20 12 6 21 6 3"></polygon>
              </svg>
            </div>
          </div>
          <div class="trailer-skeleton-info">
            <div class="skeleton-line skeleton-meta"></div>
            <div class="skeleton-line skeleton-title"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- ================= TRAILER CARDS ================= -->
    <div *ngIf="!isLoading && recommendations.length" class="trailer-cards-wrapper py-2">
          
      <button class="scroll-btn scroll-btn-left"
              *ngIf="canScrollLeft"
              (click)="scrollLeft()"
              type="button"
              aria-label="Scroll left">
        <i class="fa-solid fa-chevron-left"></i>
      </button>

      <div #trailerCardsContainer
           class="trailer-cards-container"
           (scroll)="checkScroll()">

        <div *ngFor="let movie of recommendations; let i = index"
             class="trailer-card-wrapper"
             [class.kebab-open]="activeCardIndex === i">

          <div class="trailer-card"
               [class.kebab-active]="activeCardIndex === i"
               (mouseenter)="onCardHover(i)"
               (mouseleave)="onCardLeave()">

            <img class="trailer-image"
                 loading="lazy"
                 [src]="movie.backdrop_path ? 'https://image.tmdb.org/t/p/w780' + movie.backdrop_path : (movie.poster_path ? 'https://image.tmdb.org/t/p/w780' + movie.poster_path : 'assets/images/default-backdrop.jpg')"
                 (error)="onImageError($event)"
                 [alt]="movie.title || movie.original_title || movie.name">

            <!-- Hover Overlay -->
            <div class="trailer-overlay">
              <button class="play-trailer-btn"
                      (click)="playTrailer(movie)"
                      type="button"
                      aria-label="Watch Trailer">
                <i class="fas fa-play"></i>
                <span>{{ languageService.t('watchTrailer') }}</span>
              </button>
            </div>

            <!-- Kebab -->
            <div class="kebab-position">
              <app-kebab-component
                [data]="movie"
                (toggle)="onKebabToggle($event, i)">
              </app-kebab-component>
            </div>

            <!-- Info -->
            <div class="trailer-info">
              <p class="trailer-date" *ngIf="movie.release_date || movie.first_air_date">
                {{ (movie.release_date || movie.first_air_date) | date:'MMM d, yyyy' }}
              </p>

              <a class="trailer-card-title"
                 [routerLink]="getMediaRoute(movie)">
                {{ movie.title || movie.original_title || movie.name || movie.original_name }}
              </a>
            </div>

          </div>
        </div>
      </div>

      <button class="scroll-btn scroll-btn-right"
              *ngIf="canScrollRight"
              (click)="scrollRight()"
              type="button"
              aria-label="Scroll right">
        <i class="fa-solid fa-chevron-right"></i>
      </button>

    </div>
    <div class="smoke-effect smoke-right"></div>
  </section>
</main>